import React from "react";
import R from "ramda";
import styled from "styled-components";
import { connect, } from "react-redux";

import Fade from "src/components/common/Fade";

// --------------------------------------------------

const Overlay = styled.div`
	background-color: rgba(0,0,0,0.5);
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Box = styled.div`
	background-color: white;
	padding: 3em;
`;

const enhance = connect(R.pick([ "loadingOverlay", ]));

const Comp = ({ loadingOverlay, }) => (
	<Fade visible = { !!loadingOverlay } fadeDuration = { 100 }>
		<Overlay>
			<Box>{ loadingOverlay }</Box>
		</Overlay>
	</Fade>
);

export default enhance(Comp);




// WEBPACK FOOTER //
// ./src/components/LoadingOverlay.js